<template>
  <!--ganb-->
  <Modal name="GanbAmountModal" title="銀行振込チャージ金額を選択">
    <ul class="list-group mb-3">
      <a v-for="v of config.ganbAmounts" class="list-group-item text-center" href="javascript:;" @click.prevent="ganbChargeConfirm(v)">{{ v.toLocaleString() }}円</a>
    </ul>
    <div class="mb-3">
      <label for="loginPassword" class="form-label">チャージ金額</label>
      <form @submit.prevent="ganbChargeConfirm(amount)">
        <div>
          <input type="number" class="form-control" v-model="amount" placeholder="金額を入力" min="1" max="100000" required />
        </div>
        <div class="mt-2">
          <button type="submit" class="btn btn-dark d-block w-100">次へ</button>
        </div>
      </form>
    </div>
  </Modal>
  <Modal name="GanbConfirmModal" title="振込情報をメールでお知らせします">
    <form @submit.prevent="ganbCharge(amount)">
      <div class="alert alert-light fs-4 text-center fw-bold email">
        <div class="mb-2">{{ me.email }}</div>
        <hr>
        <div class="mt-2">{{ amount.toLocaleString() }}円</div>
      </div>
      <div class="mb-3">
        <button type="submit" class="btn btn-dark fw-bold w-100">送信</button>
      </div>
      <div class="mb-4 text-center">
        <a href="javascript:;" class="text-decoration-underline" @click.prevent="openGanbAmountModal()">金額を変更</a>
      </div>
    </form>
  </Modal>
  <Modal name="GanbCompleteModal" title="振込情報を送信しました">
    <div class="mt-3 mb-4 text-center">
      受信メールをご確認ください。
    </div>
    <div class="mb-3 text-center">
      <button type="button" class="btn btn-outline-dark" @click.prevent="$modal.hide('GanbCompleteModal')">閉じる</button>
    </div>
  </Modal>
</template>

<script>
import { toast } from 'vue3-toastify';

export default {
  props: [
    'me',
    'showLoadingOverlay',
    'hideLoadingOverlay',
  ],
  data () {
    return {
      amount: '',
      config: require('../../lib/config'),
    };
  },
  mounted() {
  },
  methods: {
    show(amount) {
      if (amount) {
        this.amount = amount;
      }
      this.$modal.show('GanbAmountModal');
    },
    openGanbAmountModal() {
      this.$modal.hide('GanbConfirmModal');
      this.$modal.show('GanbAmountModal');
    },
    ganbChargeConfirm(amount) {
      this.amount = amount;
      this.$modal.hide('GanbAmountModal');
      this.$modal.show('GanbConfirmModal');
    },
    ganbCharge(amount) {
      this.showLoadingOverlay();
      const data = {
        amount: amount,
      };
      this.axios({
        url: '/ganbCharge',
        method: 'post',
        data: data,
      }).then(async (res) => {
        this.hideLoadingOverlay();
        if (res.data === false) {
          alert('振込情報の送信に失敗しました。');
          return;
        }
        this.$modal.hide('GanbConfirmModal');
        this.$modal.show('GanbCompleteModal');
      }).catch(err => {
        console.error(err);
        this.hideLoadingOverlay();
        alert('振込情報の送信に失敗しました。');
      });
    },
    ganbChargeConfirm(amount) {
      this.amount = amount;
      this.$modal.hide('GanbAmountModal');
      this.$modal.show('GanbConfirmModal');
    },
  },
}
</script>
